import React, { useState, useEffect } from "react";
import {
  Users,
  Package,
  BarChart3,
  Menu,
  X,
  FileText,
  CreditCard,
  Ruler,
  Shield,
  Settings,
  LogOut,
  ChevronRight,
  Sparkles,
  Activity,
  Bell,
  Search,
  Home,
  BookOpen,
  ArrowRight,
  Zap,
  Star,
  Heart,
  Globe,
  ChevronsLeft,
  ChevronsRight
} from "lucide-react";
import LogoutButton from "../ui/LogoutButton";

const AdminNavbar = ({ activeSection, setActiveSection, onMinimizeChange }) => {

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const navItems = [
    {
      id: "dashboard",
      icon: BarChart3,
      label: "Dashboard",
      description: "Overview & Analytics",
      color: "from-blue-500 to-blue-600"
    },
    {
      id: "users",
      icon: Users,
      label: "Admin Users",
      description: "User Management",
      color: "from-green-500 to-emerald-600"
    },
    {
      id: "Products",
      icon: Package,
      label: "Products",
      description: "Product Catalog",
      color: "from-purple-500 to-pink-600"
    },
    {
      id: "devis",
      icon: FileText,
      label: "Quotes",
      description: "Quote Management",
      color: "from-orange-500 to-red-600"
    },
    {
      id: "Payement",
      icon: CreditCard,
      label: "Payments",
      description: "Payment Processing",
      color: "from-emerald-500 to-teal-600"
    },
    {
      id: "sizes",
      icon: Ruler,
      label: "Sizes",
      description: "Size Management",
      color: "from-indigo-500 to-purple-600"
    },
    {
      id: "contact",
      icon: Ruler,
      label: "Contact",
      description: "Contact Message",
      color: "from-indigo-500 to-purple-600"
    },    
    // { 
    //   id: "Blog", 
    //   icon: BookOpen, 
    //   label: "Blog", 
    //   description: "Content Management",
    //   color: "from-pink-500 to-rose-600"
    // },
  ];

  useEffect(() => {
    if (typeof onMinimizeChange === "function") {
      onMinimizeChange(isMinimized);
    }
  }, [isMinimized]);
  


  const NavContent = () => (
    <nav className="space-y-3">
      {navItems.map((item, index) => {
        const Icon = item.icon;
        const isActive = activeSection === item.id;
        return (
          <button
            key={item.id}
            onClick={() => {
              setActiveSection(item.id);
              setIsMobileMenuOpen(false);
            }}
            className={`group relative w-full flex items-center space-x-4 p-4 rounded-2xl transition-all duration-300 transform hover:scale-105 ${isActive
                ? "bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 shadow-lg"
                : "hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-100 hover:shadow-md"
              }`}
            style={{
              animationDelay: `${index * 100}ms`
            }}
          >
            {/* Icon Container */}
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 ${isActive
                ? `bg-gradient-to-r ${item.color} shadow-lg`
                : "bg-gray-100 group-hover:bg-gradient-to-r group-hover:from-gray-200 group-hover:to-gray-300"
              }`}>
              <Icon className={`w-6 h-6 transition-colors duration-300 ${isActive ? "text-white" : "text-gray-600 group-hover:text-gray-700"
                }`} />
            </div>

            {/* Text Content */}
            <div className="flex-1 text-left">
              <div className={`font-semibold text-base transition-colors duration-300 ${isActive ? "text-green-700" : "text-gray-700 group-hover:text-gray-900"
                }`}>
                {item.label}
              </div>
              <div className={`text-sm transition-colors duration-300 ${isActive ? "text-green-600" : "text-gray-500 group-hover:text-gray-600"
                }`}>
                {item.description}
              </div>
            </div>

            {/* Active Indicator */}
            {isActive && (
              <div className="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full animate-pulse"></div>
            )}

            {/* Hover Arrow */}
            <ChevronRight className={`w-5 h-5 transition-all duration-300 ${isActive ? "text-green-600" : "text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1"
              }`} />
          </button>
        );
      })}
    </nav>
  );

  // Minimized version of the navigation
  const MinimizedNavContent = () => (
    <nav className="space-y-3 flex flex-col items-center">
      {navItems.map((item, index) => {
        const Icon = item.icon;
        const isActive = activeSection === item.id;
        return (
          <button
            key={item.id}
            onClick={() => {
              setActiveSection(item.id);
              setIsMobileMenuOpen(false);
            }}
            className={`group relative w-14 h-14 flex flex-col items-center justify-center rounded-xl transition-all duration-300 transform hover:scale-105 ${isActive
                ? "bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 shadow-lg"
                : "hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-100 hover:shadow-md"
              }`}
            style={{
              animationDelay: `${index * 100}ms`
            }}
            title={`${item.label} - ${item.description}`}
          >
            {/* Icon Container */}
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 ${isActive
                ? `bg-gradient-to-r ${item.color} shadow-lg`
                : "bg-gray-100 group-hover:bg-gradient-to-r group-hover:from-gray-200 group-hover:to-gray-300"
              }`}>
              <Icon className={`w-5 h-5 transition-colors duration-300 ${isActive ? "text-white" : "text-gray-600 group-hover:text-gray-700"
                }`} />
            </div>

            {/* Active Indicator */}
            {isActive && (
              <div className="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full animate-pulse mt-1"></div>
            )}
          </button>
        );
      })}
    </nav>
  );

  return (
    <>
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-lg shadow-xl border-b border-white/20 z-50">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Admin Panel</h2>
              <p className="text-xs text-gray-500">Green Eco Bags USA</p>
            </div>
          </div>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="group relative w-12 h-12 bg-gradient-to-r from-green-100 to-emerald-100 hover:from-green-200 hover:to-emerald-200 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-105"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-green-600 group-hover:text-green-700" />
            ) : (
              <Menu className="w-6 h-6 text-green-600 group-hover:text-green-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed top-0 left-0 w-80 h-full bg-white/90 backdrop-blur-lg shadow-2xl border-r border-white/20 z-50 transform transition-all duration-300 ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <div className="p-6 flex flex-col h-full overflow-hidden">
          {/* Mobile Header */}
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-green-600 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg">
                <Shield className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">Admin Panel</h2>
                <p className="text-sm text-gray-500">Green Eco Bags USA</p>
              </div>
            </div>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-colors duration-300"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          {/* Navigation */}
          <div className="flex-1 overflow-y-auto">
            <NavContent />
          </div>

          {/* Logout Section */}
          <div className="mt-auto pt-6 border-t border-gray-200">
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-4 border border-gray-200">
              <LogoutButton />
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <aside className={`fixed left-0 top-0 h-full ${isMinimized ? 'w-20' : 'w-80'} bg-white/80 backdrop-blur-lg shadow-2xl border-r border-white/20 hidden lg:flex flex-col transition-all duration-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
        {/* Background Elements */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-20 right-4 w-16 h-16 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-20 right-8 w-12 h-12 bg-emerald-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
        </div>

        {/* Minimize/Expand Toggle Button */}
        <button
          onClick={() => setIsMinimized(!isMinimized)}
          className="absolute -right-4 top-20 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 z-10 transition-all duration-300 hover:bg-green-50 hover:border-green-200 transform hover:scale-110"
        >
          {isMinimized ?
            <ChevronsRight className="w-4 h-4 text-green-600" /> :
            <ChevronsLeft className="w-4 h-4 text-green-600" />
          }
        </button>

        <div className={`${isMinimized ? 'p-3' : 'p-6'} flex flex-col h-full`}>
          {/* Header Section */}
          <div className={`${isMinimized ? 'mb-6 flex justify-center' : 'mb-8'}`}>
            {isMinimized ? (
              <div className="w-12 h-12 bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
                <Shield className="w-6 h-6 text-white" />
              </div>
            ) : (
              <>
                <div className="flex items-center space-x-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg">
                    <Shield className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900">Admin Panel</h2>
                    <p className="text-sm text-gray-500">Green Eco Bags USA</p>
                  </div>
                </div>

                {/* Status Badge */}
                <div className="flex items-center space-x-2 bg-green-50 text-green-700 px-3 py-2 rounded-xl border border-green-200">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">System Online</span>
                </div>
              </>
            )}
          </div>

          {/* Navigation */}
          <div className="flex-1 overflow-y-auto">
            {!isMinimized && (
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Navigation</h3>
              </div>
            )}
            {isMinimized ? <MinimizedNavContent /> : <NavContent />}
          </div>

          {/* Footer Section */}
          {!isMinimized && (
            <div className="mt-auto pt-6 border-t border-gray-200">
              {/* Quick Actions */}


              {/* Logout Section */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-4 border border-gray-200">
                <LogoutButton />
              </div>
            </div>
          )}

          {/* Minimized Footer - Just Logout */}
          {isMinimized && (
            <div className="mt-auto flex justify-center">
              <button
                onClick={() => {/* Logout logic */ }}
                className="w-12 h-12 bg-gradient-to-r from-red-50 to-red-100 hover:from-red-100 hover:to-red-200 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-105 border border-red-200"
              >
                <LogOut className="w-5 h-5 text-red-600" />
              </button>
            </div>
          )}
        </div>

        {/* Custom Styles */}
        <style jsx>{`
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          
          /* Custom Scrollbar */
          .overflow-y-auto::-webkit-scrollbar {
            width: 6px;
          }
          
          .overflow-y-auto::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 10px;
          }
          
          .overflow-y-auto::-webkit-scrollbar-thumb {
            background: linear-gradient(180deg, #10b981, #059669);
            border-radius: 10px;
            transition: all 0.3s ease;
          }
          
          .overflow-y-auto::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(180deg, #059669, #047857);
            transform: scale(1.1);
          }
          
          .overflow-y-auto::-webkit-scrollbar-thumb:active {
            background: linear-gradient(180deg, #047857, #065f46);
          }
          
          /* Firefox Scrollbar */
          .overflow-y-auto {
            scrollbar-width: thin;
            scrollbar-color: #10b981 transparent;
          }
          
          .overflow-y-auto:hover {
            scrollbar-color: #059669 transparent;
          }
        `}</style>
      </aside>
    </>
  );
};

export default AdminNavbar;
